const normalizeMarcasText = (marcas) => {
  if (!marcas) return "";
  if (Array.isArray(marcas)) {
    return marcas.map((marca) => String(marca).trim()).join(" ").toLowerCase();
  }
  return String(marcas).replace(/[,;]/g, " ").toLowerCase();
};

export const customerMatchesSearch = (customer, searchTerm) => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return true;

  const name = customer.name ? String(customer.name).toLowerCase() : "";
  const marcasText = normalizeMarcasText(customer.marcas);

  return name.includes(term) || marcasText.includes(term);
};
